import { AppRoutes } from '../../../Core/App/AppRoutes';
import { AppRouteType } from '../../Components/Templates/AppRouter/AppRouteType';
import { PrivateRoute } from '../../Components/Templates/AppRouter/PrivateRoute';
import { LoadableListCauseriePage } from '../../Pages/Causeries/ListCauserie/LoadableListCauseriePage';
import { LoadableCauserieCreatePage } from '../../Pages/Causeries/CauserieCreate/LoadableCauserieCreate';
import { LoadableCauserieDetailsPage } from '../../Pages/Causeries/CauserieDetails/LoadableCauseriePage';

const getListCauserieRoute = (props: object): AppRouteType => ({
    id: AppRoutes.CAUSERIE_LIST,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.CAUSERIE_LIST,
        component: LoadableListCauseriePage,
        ...props,
    },
});

const getCauserieCreateRoute = (props: object): AppRouteType => ({
    id: AppRoutes.CAUSERIE_CREATE,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.CAUSERIE_CREATE,
        component: LoadableCauserieCreatePage,
        ...props,
    },
});

const getCauserieDetailsRoute = (props: object): AppRouteType => ({
    id: AppRoutes.CAUSERIE_DETAILS,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.CAUSERIE_DETAILS,
        component: LoadableCauserieDetailsPage,
        ...props,
    },
});

export const getCauserieRoutes = (args: object) => [
    getListCauserieRoute(args),
    getCauserieCreateRoute(args),
    getCauserieDetailsRoute(args),
];
